import z from "zod";
import {
  ActivationStatusFilterEnum,
  PortoutStatusFilterEnum,
} from "./filter/filterEnum";

export const SimSearchSchema = z.object({
  page: z.number().optional().catch(1),
  limit: z.number().optional().catch(100),
  activation_status: z
    .enum(ActivationStatusFilterEnum)
    .optional()
    .catch(ActivationStatusFilterEnum.all),
  portout_status: z
    .enum(PortoutStatusFilterEnum)
    .optional()
    .catch(PortoutStatusFilterEnum.all),
  iccid: z
    .string()
    .trim()
    .max(20)
    .optional()
    .catch(undefined),
  sim_tel: z
    .string()
    .trim()
    .max(15)
    .optional()
    .catch(undefined),
});

export type SearchSimQuery = z.infer<typeof SimSearchSchema>;
